<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <div class="text-center">
      <span class="text-zt-lg" :class="primaryTextClass">
        {{ $t("message.LicensesSolicitudeComponent.fileUploadMessage") }}
      </span>
    </div>
    <div class="w-full mt-2 mx-auto">
      <FileUpload
        :metadata="metadata"
        @documents="setDocuments"
        :documents-from-request="safeDocumentsFromRequest"
      />
    </div>
  </div>
</template>

<script>
import FileUpload from '@/views/FileUploadPage'
import { state as importedState, mutations as importedMutations } from '@/modules/Licenses/components/Observables/useLicenseHistory.js'

export default {
  components: {
    FileUpload
  },
  data() {
    return {
      metadata: importedState.uploadFilesMetaData
    }
  },
  computed: {
    isInIframe() {
      return window.self !== window.top
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-100'
    },
    safeDocumentsFromRequest() {
      return importedState.request && Array.isArray(importedState.request.documents)
        ? importedState.request.documents
        : [];
    }
  },
  methods: {
    setDocuments(value) {
      importedMutations.addParamToRequest({ documents: value });   
    }
  }
}
</script>

<style scoped lang="scss">
.text-iframe-primary {
  color: #2694fc !important;
}
</style>